import { useState, useEffect } from "react";

import validate from './LaneSheetRightSideNotesDetailFormValidation';

import useForm from "@usas/ui-web/utils/UseForm";
import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
  displayOrder: Constants.DEFAULT_ID,
  nameToShow: '',
  recordsToShow: '',
  recordListId: Constants.DEFAULT_ID,
  listName: '',
  isRelayOnly: false
};

const useLaneSheetRightSideNotesDetailForm = (onSubmitFormCallback, rightSideDataLength) => {
  const { formState, errorState, handleSubmit, onFormValueChanged, onValueTextPairChanged
  } = useForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);
  const [displayOrderOptionsState, setDisplayOrderOptionsState] = useState([]);

  useEffect(() => {
    const displayOrderOptions = [];

    for (let i = 0; i < rightSideDataLength + 1; i++) {
      displayOrderOptions.push({
        id: i + 1,
        value: i + 1,
        name: i + 1
      });
    }

    setDisplayOrderOptionsState(displayOrderOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rightSideDataLength]);

  return {
    formState,
    errorState,
    onFormValueChanged,
    handleSubmit,
    onValueTextPairChanged,
    displayOrderOptionsState
  };
};

export default useLaneSheetRightSideNotesDetailForm;